import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMealMate } from "../../context/MealMateContext";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { api, endpoints } from "../../utils/axiosInstance";
import { authService } from "../../services/authService"; // ✅ Thêm dòng này

const LoginSuccessGooglePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setIsAuthenticated } = useMealMate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const processGoogleLogin = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        const userInfoStr = params.get("userInfo");

        if (!token || !userInfoStr) {
          throw new Error("Không nhận được thông tin xác thực");
        }

        // ✅ Lưu token vào sessionStorage
        sessionStorage.setItem("token", token);
        
        // ✅ Dùng authService để lấy đầy đủ profile (bao gồm cả notificationSettings)
        let userInfo;
        try {
          userInfo = await authService.handleGoogleCallback(token);
        } catch (err) {
          console.warn("Fallback sang logic cũ do handleGoogleCallback thất bại");
        }

        if (!userInfo) {
          // ✅ Nếu authService không hoạt động, fallback sang cách cũ
          const response = await api.get(endpoints.user.profile);

          if (!response || !response.data) {
            throw new Error("Response không hợp lệ từ server");
          }

          if (!response.success) {
            throw new Error(
              response.data.message || "Không thể lấy thông tin người dùng"
            );
          }

          const userProfile = response.data;
          const initialUserInfo = JSON.parse(userInfoStr);

          userInfo = {
            _id: userProfile._id,
            full_name: userProfile.full_name,
            email: userProfile.email,
            phone: userProfile.phone,
            role: initialUserInfo.role,
            profile_picture: userProfile.profile_picture,
            authProvider: userProfile.authProvider,
            gender: userProfile.gender,
            height: userProfile.height,
            weight: userProfile.weight,
            date_of_birth: userProfile.date_of_birth,
            job: userProfile.job,
            activity_level: userProfile.activity_level,
            goal: userProfile.goal,
            calorieGoal: userProfile.calorieGoal,
            proteinGoal: userProfile.proteinGoal,
            fatGoal: userProfile.fatGoal,
            carbGoal: userProfile.carbGoal,
          };
        }

        // ✅ Set user và chuyển hướng
        setUser(userInfo);
        setIsAuthenticated(true);
        message.success("Đăng nhập thành công!");
        navigate("/account");
      } catch (error) {
        console.error("Lỗi xử lý đăng nhập Google:", error);
        setError(error.message || "Đăng nhập thất bại");
        message.error(error.message || "Đăng nhập thất bại. Vui lòng thử lại.");

        sessionStorage.removeItem("token");
        setUser(null);
        setIsAuthenticated(false);

        setTimeout(() => navigate("/"), 3000);
      } finally {
        setIsLoading(false);
      }
    };

    processGoogleLogin();
  }, [location, navigate, setUser, setIsAuthenticated]);

  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Spin indicator={antIcon} spinning={isLoading} />
      <div
        style={{
          marginTop: 20,
          fontSize: 16,
          maxWidth: "400px",
          wordWrap: "break-word",
        }}
      >
        {error ? (
          <div style={{ color: "red" }}>{error}</div>
        ) : isLoading ? (
          "Đang xử lý đăng nhập..."
        ) : (
          "Đăng nhập thành công, đang chuyển hướng..."
        )}
      </div>
    </div>
  );
};

export default LoginSuccessGooglePage;
